export * from 'server/models/CoordinationCardRelevance';


// WEBPACK FOOTER //
// ./data/models/CoordinationCardRelevance.ts